import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/slices/formconfig';
import './style.css'; // You'll need to create this CSS file

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: (reason: string, internalRemarks: string) => void;
}

const RejectModal: React.FC<Props> = ({ show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [reason, setReason] = React.useState('');
  const [internalRemarks, setInternalRemarks] = React.useState('');

  if (!show) {
    return null;
  }

  const handleReject = () => {
    if (isFormValid) {
      onSubmit(reason, internalRemarks);
      setReason('');
      setInternalRemarks('');
    } else {
      dispatch(showToast({ message: 'Please fill out all required fields.', type: 'error' })); // This can be improved with more specific messages
    }
  };
  
  const isOtherReasonSelected = reason === 'Other';

  // Updated validation check
  const isFormValid = reason !== '' && (!isOtherReasonSelected || (isOtherReasonSelected && internalRemarks !== ''));



  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{padding:20}}>
        <div className="modal-header">
          <span className='headerreject'>Reject Certificate</span>
          <span className="close-button" onClick={onClose}>&times;</span>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className='subhead'>Reason visible to partner <mark style={{background:'transparent', color:'red'}}>*</mark></label>
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            >
              <option value="">Choose a reason the partner will see</option>
              <option value="License copy uploaded is not clear">License copy uploaded is not clear</option>
              <option value="Valid license number is not entered">Valid license number is not entered</option>
              <option value="Updated license issue date is incorrect">Updated license issue date is incorrect</option>
              <option value="Updated license expiry date is incorrect">Updated license expiry date is incorrect</option>
              <option value="License has expired">License has expired</option>
              <option value="Incorrect firm name, resubmit request with correct firm name as per pesticide license.">Incorrect firm name, resubmit request with correct firm name as per pesticide license.</option>
              <option value="Shop address is incorrect">Shop address is incorrect</option>
              <option value="Godown address is incorrect">Godown address is incorrect</option>
              <option value="District/Jurisdiction updated is incorrect">District/Jurisdiction updated is incorrect</option>
              <option value="Request ID from Mahaparwana portal is incorrect (only for Maharashtra users)">Request ID from Mahaparwana portal is incorrect (only for Maharashtra users)</option>
              <option value="Please contact your Bayer representative for more information">(Other) Please contact your Bayer representative for more information</option>
            </select>
          </div>
          
            <div className="form-group">
              <label className='subhead'>Internal remarks <mark style={{background:'transparent', color:'red'}}>*</mark></label>
              <textarea
                value={internalRemarks}
                onChange={(e) => setInternalRemarks(e.target.value)}
                placeholder="Add detailed notes for the internal team here..."
              />
            </div>
       
        </div>
        <div className="modal-footer">
          <button
            className={isFormValid?"reject-request-button": "reject-request-button disabled"}
            onClick={handleReject}
            disabled={!isFormValid}
          >
            Reject Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;